<template>

<v-container>
 
  


 <v-row no-gutters>
  <v-col>
 <h4>Location Name</h4>
   <h1>{{this.locationName}}
     <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>


     
            <v-list>
              <v-list-item @click="editLocation($route.params.id)">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu></h1>
  </v-col>

  <v-col class="text-right">

<v-card class="ml-5" max-width="130" style="display:inline-block; padding:10px;" @click="subView='QRCodes'">
<h4>{{codes.length}}</h4>
<h3>QR Codes</h3>
</v-card>

<v-card class="ml-5" max-width="130" style="display:inline-block;padding:10px;" @click="subView='Checkins'">
<h4>{{checkins.length}}</h4>
<h3>Checkins</h3>
</v-card>
  </v-col>
 </v-row>

<v-row v-if="subView=='QRCodes'">
<v-col v-if="codes.length > 0">

   <v-btn-toggle class="mb-5" v-model="tile">

   <v-btn>
          <v-icon>mdi-view-list</v-icon>
        </v-btn>

        <v-btn>
          <v-icon>mdi-apps</v-icon>
        </v-btn>

     

   </v-btn-toggle>

 <div v-if="tile==1">

<v-card class="text-center pa-5 mr-3 mb-3 float-left" max-width="200" v-for="(c, index) in codes" :key="index">

<qrcode-vue class="mx-0" :value="returnQRURL(c.locationId, c.id)" :size="150" foreground="#A3080B" level="L"></qrcode-vue>



<a target="_blank" :href="returnQRURL(c.locationId, c.id)">View Link</a>
</v-card>


 </div>
 <div v-else>


 <v-data-table
    :headers="codeTableHeaders"
    :items="codes"
    :items-per-page="10"
    class="elevation-1"
  >
  <template v-slot:item.id2="{ item }">
           
    <v-icon>mdi-qrcode</v-icon>

      </template>  
  
  <template v-slot:item.id="{ item }">
           
      <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="editCode(item.id)">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
      </template>

  </v-data-table>



   </div>





</v-col>
</v-row>
<v-row v-if="subView=='QRCodes'">
<v-col>
  <v-btn rounded class="primary pa-5 mt-3" max-width="200" @click="addNewQRCode">
  Add QR Code
</v-btn>

</v-col>
</v-row>


<v-row v-if="subView=='Checkins'">
  <v-col v-if="checkins.length > 0">
 <v-data-table
    :headers="tableSigninHeaders"
    :items="checkins"
    :items-per-page="10"
    class="elevation-1"
  >
  <template v-slot:item.dateTimeUTC="{ item }">
        {{dateFromNow(item.dateTimeUTC)}} 
      </template>



  </v-data-table>
  <v-btn rounded class="primary pa-5 mt-3" max-width="200" @click="downloadXLSX">
  Download 
</v-btn>
  </v-col>
  <v-col v-else>

<v-card>
<v-card-text class="pa-2 text-center" style="">
  
    <iframe width="640" height="360" src="https://www.youtube.com/embed/MX6MvV8cbh8" class="ma-4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

    <h3 class="mb-5">There hasn't been any checkin's on this location yet.</h3>
</v-card-text>
</v-card>

  </v-col>
</v-row>

</v-container>
</template>

<script>
import FileSaver from 'file-saver'
import axios from 'axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);

  import { mapActions, mapGetters } from 'vuex';

import QrcodeVue from 'qrcode.vue'
  export default {
    name: 'Home',


computed:{
     ...mapGetters(["getAxiosConfig","getAxiosConfigBlob","returnAccount","getLocationByID"]),
     locationName:function(){
      return this.getLocationByID(this.$route.params.id).title;
     }
},
created: function () {
    // `this` points to the vm instance
var t = this;
    this.returnLocationCheckIns(t.$route.params.id).then(function(checkins){

      t.checkins = checkins;

    });
    this.returnQRCodes(t.$route.params.id).then(function(qrcodes){


      t.codes = qrcodes;



    });


  },



    components: {
 QrcodeVue
    },
    methods: {
      
        ...mapActions([
      "returnLocationCheckIns",
      "returnQRCodes",
      "addQRCode",
      "getToken",
          ]),
editLocation(id){


       this.$router.push(this.$route.params.id + '/edit');

},
dateFromNow(date){
  return  dayjs.utc(date).local().fromNow()
},
s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
},
downloadXLSX(){
var t = this;

  t.getToken().then(token=>{

                 axios.post(
                  t.GLOBAL_CONFIG.apiURL + "locations/"+ t.$route.params.id +"/Checkins/Download",
                  {},
                  t.getAxiosConfigBlob
                  ).then(data=>{
                 
                 
                          var bin = atob(data.data);
    var ab = t.s2ab(bin); // from example above
    var blob = new Blob([ab], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });

    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'QRCodeCheckins.xlsx';

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

                    
                  }).catch(exception=>{t.errormessage="Error getting account details";});
  });

},
editCode(code){
  
  
     this.$router.push('venue/' + this.$route.params.id + '/code/' + code);

},
addNewQRCode(){

  var t= this;
  t.addQRCode(
    {
    ValidFromUTC:"2000-01-01",
    LocationID:t.$route.params.id,
    ValidUntilUTC:"2100-01-01",
    Active:true
    }
    ).then(function(data){
      t.returnQRCodes(t.$route.params.id).then(function(codes){
        t.codes =codes;
      });
    })
    },

      returnQRURL(a,b){
        return this.GLOBAL_CONFIG.frontURL +"s/" + a + "/" + b;
      }
    },
    data:function(){
      return {
        subView: "QRCodes",
    tableSigninHeaders:[
       
          { text: 'Name', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Mobile', value: 'mobile' },
          { text: 'Date Time', value: 'dateTimeUTC' },
        ],
        codeTableHeaders:[
       
          { text: 'Valid From', value: 'validFromUTC' },
          { text: 'Valid Until', value: 'validUntilUTC' },
          { text: 'Active', value: 'active' },
          { text: '', value: 'id2', width: '50px', },
          { text: '', value: 'id', width: '50px', },
        ],
        tile:0,
        checkins:[],
        codes:[{
Id: "9467E4B4-8A2E-4199-80BA-E4FD053537CC",
LocationID:"C4E877F4-E456-430F-7741-08D87A63B387",
	ValidFromUTC:"2020-01-01 00:00:00.0000000",
  ValidUntilUTC:"2020-12-12 00:00:00.0000000",
  	Active:	1}

        ]
      }
    }
  }
</script>
